import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0f7a6e",
        secondary: "#54a9f8",
        accent: "#e31e24",
        error: "#e31e24",
        info: "#54a9f8",
        success: "#0f7a6e",
        warning: "#d98324",
      },
    },
  },
});
